export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 15.146a3.5 3.5 0 11-2 0V11H17V8h1.5V6h2v9.146zM19.5 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3z\" fill=\"#7B61FF\"/><path d=\"M12 12c1.558 0 3.038.284 4.36.795l-.72 1.865A10.11 10.11 0 0012 14c-4.159 0-7.256 2.308-7.882 5H14v2H3a1 1 0 01-1-1c0-4.638 4.726-8 10-8z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2.5a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};